import { render, staticRenderFns } from "./-TabContainer1.vue?vue&type=template&id=09e6bfe8&scoped=true&"
import script from "./-TabContainer1.vue?vue&type=script&lang=js&"
export * from "./-TabContainer1.vue?vue&type=script&lang=js&"
import style0 from "./-TabContainer1.vue?vue&type=style&index=0&id=09e6bfe8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e6bfe8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OssImg: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/OssImg.vue').default,LinkTo: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/LinkTo.vue').default,Animation: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/animation/index.vue').default,TabsBasic: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/tabs/basic.vue').default})
